import { useState } from "react";

import chevronDown from "../../assets/svg/chevron-down.svg";

interface DropdownSmallProps {
  options: {
    label: string;
    value: string | number;
  }[];
  selected?: string | number;
  onChange?: (value: string) => void;
  disabled?: boolean;
  defaultOption?: string;
}

const DropdownSmall: React.FC<DropdownSmallProps> = ({
  options,
  selected = "",
  onChange,
  disabled = false,
  defaultOption = "Select Vehicle",
}) => {
  // const { setSelectedVehicleId } = useBooking();
  const [optionsOpen, setOptionsOpen] = useState(false);

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const value = event.target.value;
    const parsedValue = value ? parseInt(value) : null;
    // setSelectedVehicleId(parsedValue);
    onChange?.(parsedValue ? parsedValue.toString() : "");
  };

  return (
    <>
      <div className="hidden md:block relative font-montserrat">
        <select
          className="w-full min-w-[150px] p-0 pr-8 text-base bg-transparent appearance-none border-0 border-b-2 border-gray-400 focus:outline-none focus:border-black text-[14px] disabled:opacity-50 disabled:cursor-not-allowed"
          onChange={handleChange}
          value={selected?.toString() ?? ""}
          disabled={disabled}
        >
          <option value="">{defaultOption}</option>
          {options.map((option) => (
            <option
              key={option.value.toString()}
              value={option.value.toString()}
              className="text-black"
            >
              {option.label}
            </option>
          ))}
        </select>
        <img
          src={chevronDown}
          alt="chevron-down"
          className="pointer-events-none absolute right-2 top-1/2 -translate-y-1/2 w-[25px] h-[25px]"
        />
      </div>

      <div className="block md:hidden w-full">
        <div
          className="flex items-center justify-between border-0 border-b-2 border-gray-400 hover:cursor-pointer"
          onClick={() => setOptionsOpen(!optionsOpen)}
        >
          <p className="text-sm">
            {options.find(
              (option) => option.value.toString() === selected?.toString(),
            )?.label || defaultOption}
          </p>
          <img
            src={chevronDown}
            alt="chevron-down"
            className="w-[25px] h-[25px]"
          />
        </div>
        <div
          className={`${optionsOpen ? "fixed inset-0 z-50 flex items-center justify-center bg-black/20" : "hidden"}`}
        >
          <div className="relative bg-white w-[270px] rounded-xl shadow-lg max-h-[60vh] p-6">
            {/* Close button */}
            <button
              className="absolute right-[-18px] top-[-18px] flex items-center justify-center rounded-full border border-gray-400 bg-white hover:bg-gray-100 transition"
              onClick={() => setOptionsOpen(false)}
              aria-label="Close"
              tabIndex={0}
            >
              <span className="sr-only">Close</span>
              <svg
                width="36"
                height="36"
                viewBox="0 0 36 36"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="18" cy="18" r="18" fill="#F1F1F1" />
                <path
                  d="M18 28C23.5228 28 28 23.5228 28 18C28 12.4772 23.5228 8 18 8C12.4772 8 8 12.4772 8 18C8 23.5228 12.4772 28 18 28Z"
                  stroke="black"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M15 15L21 21"
                  stroke="black"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M21 15L15 21"
                  stroke="black"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
            <div className="border-b border-black">
              <p className="text-[16px] font-normal text-black">Choose Model</p>
            </div>
            <div className="overflow-y-auto max-h-[54vh]">
              {options.map((option) => (
                <div
                  key={option.value.toString()}
                  className="py-3 cursor-pointer"
                  onClick={() => {
                    const parsedValue =
                      typeof option.value === "string"
                        ? parseInt(option.value)
                        : option.value;
                    // setSelectedVehicleId(parsedValue);
                    onChange?.(parsedValue ? parsedValue.toString() : "");
                    setOptionsOpen(false);
                  }}
                >
                  <p className="text-[16px] text-black">{option.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DropdownSmall;
